<template>
  <div class="sitemanage">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>站点配置</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-loading="isRefresh">
      <div class="main">
        <h4>站点配置</h4>
        <el-tabs v-model="activeName"
                 type="border-card"
                 @tab-click="handleClick">
          <el-tab-pane label="基本信息"
                       name="first">
            <div class="upbg">

              <el-form :model="ruleForm"
                       :rules="rules"
                       ref="ruleForm"
                       label-width="100px"
                       class="demo-ruleForm">
                <el-row style="margin-bottom:10px;">
                  <el-col :span="12">
                    <el-form-item label="网站标题:"
                                  prop="title">
                      <el-input v-model="ruleForm.title"
                                placeholder="选填，40个字以内"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="网站关键词:"
                                  prop="word">
                      <el-input v-model="ruleForm.word"
                                placeholder="选填，60个字以内"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>

                <el-row style="margin-bottom:10px;">
                  <el-col :span="12">
                    <el-form-item label="网站摘要:"
                                  prop="abstract">
                      <el-input v-model="ruleForm.abstract"
                                placeholder="选填，200个字以内"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="站点状态:"
                                  prop="websiteStatus">
                      <el-radio-group v-model="ruleForm.websiteStatus"
                                      :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                      size="small">
                        <el-radio-button label="off">关闭</el-radio-button>
                        <el-radio-button label="open">开启</el-radio-button>
                        <el-radio-button label="grey">灰色</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row style="margin-bottom:10px;">
                  <el-col :span="12">
                    <el-form-item label="站点模板:"
                                  prop="theme">
                      <el-select style="width:100%;"
                                 v-model="ruleForm.theme"
                                 placeholder="请选择">
                        <el-option v-for="item in themeList"
                                   :key="item.value"
                                   :label="item.title"
                                   :value="item.value"
                                   v-html="'<span style=color:#303030;>'+item.title+'</span>'"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="网站LOGO:"
                                  prop="psw">
                      <div style="float:left;position: relative;margin-right:40px;margin-left:20px;">
                        <el-upload class="upload-demo"
                                   action="#"
                                   :show-file-list="false"
                                   :auto-upload="false"
                                   :on-change="onChange">
                          <!-- <el-tooltip class="item" effect="dark" content="图片大小最好为：1920 * 300" placement="top"> -->
                          <div v-if="!thumbnailFile && !isFile"
                               :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">点击上传</div>
                          <!-- </el-tooltip> -->
                          <div v-if="isFile"
                              :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
                            <i class="el-icon-loading"></i> <span>正在上传!</span>
                          </div>

                        </el-upload>

                        <div v-if="thumbnailFile"
                             class="imgbj">
                          <el-image lazy
                                    class="imgs"
                                    :src="thumbnailFile.src"
                                    :preview-src-list="[thumbnailFile.src]"></el-image>
                          <p @click.stop="deleteThumbnailFile"
                            :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                             class="delete">删除</p>
                          <!-- <div @click.stop="deleteThumbnailFile" class="delete">
                            <img width="15px" src="@/assets/piclist/mydel.png" alt />
                          </div> -->
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="网站徽标:"
                                  prop="psw">

                      <div style="float:left;position: relative;margin-right:40px;margin-left:20px;">
                        <el-upload class="upload-demoMo"
                                   action="#"
                                   :show-file-list="false"
                                   :auto-upload="false"
                                   :on-change="onChangeMo">
                          <!-- <el-tooltip class="item" effect="dark" content="图片大小最好为：1920 * 300" placement="top"> -->
                          <div v-if="!thumbnailFileMo && !isFileMo"
                               :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">点击上传</div>
                          <!-- </el-tooltip> -->
                          <div v-if="isFileMo"
                               :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
                            <i class="el-icon-loading"></i> <span>正在上传!</span>
                          </div>

                        </el-upload>

                        <div v-if="thumbnailFileMo"
                             class="imgbj">
                          <el-image lazy
                                    class="imgs"
                                    :src="thumbnailFileMo.src"
                                    :preview-src-list="[thumbnailFileMo.src]"></el-image>
                          <p @click.stop="deleteThumbnailFileMo"
                            :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                             class="delete">删除</p>
                          <!-- <div @click.stop="deleteThumbnailFile" class="delete">
                            <img width="15px" src="@/assets/piclist/mydel.png" alt />
                          </div> -->
                        </div>
                      </div>

                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="底部版权信息:"
                              prop="desc">

                  <div id="websiteEditorElem"
                       style="height:400px;background: #ffffff;"></div>
                </el-form-item>

              </el-form>

            </div>
          </el-tab-pane>
          <el-tab-pane label="栏目设置"
                       name="second">
            <div>
              <div class="custom-tree-node"
                   style="margin-bottom:10px;">
                <p>主站点</p>
                <div class="btn">
                  <el-button type="text"
                             size="mini"
                             :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                             @click="() => appendChannel(node,data)">
                    + 添加频道
                  </el-button>
                </div>
              </div>
              <!-- draggable
                @node-drop="nodedrop"
                :allow-drop="allowDrop" -->
              <el-tree :data="data"
                       node-key="id"
                       default-expand-all
                       style="width:100%;"
                       :draggable='true'
                       @node-drop="nodedrop"
                       :allow-drop="allowDrop"
                       :expand-on-click-node="false">
                <span class="custom-tree-node"
                      slot-scope="{ node, data }">
                  <div>{{ node.label }}</div>
                  <div class="btn">

                    <el-button type="text"
                               size="mini"
                               v-if="node.level == 1"
                               :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                               @click="() => appendColumn(node,data)">
                      + 添加栏目
                    </el-button>
                    <el-button type="text"
                               size="mini"
                               :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                               v-if="node.level == 1 || node.level == 2"
                               @click="() => change(node, data)">
                      修改
                    </el-button>
                    <el-button type="text"
                               size="mini"
                               :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                               :disabled="node.childNodes.length > 0"
                               v-if="node.level == 1 || node.level == 2"
                               @click="() => remove(node, data)">
                      删除
                    </el-button>
                  </div>
                </span>
              </el-tree>
            </div>
          </el-tab-pane>

          <el-tab-pane label="友情链接"
                       name="third">
            <div class="upbg">

              <div class="noYou"
                   v-if="dynamicValidateForm.domains.length <= 0">
                <el-button class="addbtn"
                           @click.prevent="addDomain()">添加友情链接</el-button>
              </div>

              <el-form :model="dynamicValidateForm"
                       ref="dynamicValidateForm"
                       label-width="100px"
                       class="demo-ruleForm">
                <el-row v-for="(domain, index) in dynamicValidateForm.domains"
                        :key="index"
                        style="margin-bottom:10px;">
                  <el-col :span="6">
                    <el-form-item label="链接标题:"
                                  :prop="'domains.' + index + '.title'"
                                  :rules="{
                                    required: true, message: '链接标题不能为空', trigger: 'blur'
                                  }">
                      <el-input v-model="domain.title"
                                placeholder="请输入链接标题！"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item label="链接网址:"
                                  label-width="90px"
                                  :prop="'domains.' + index + '.url'"
                                  :rules="{
                                    required: true, message: '链接网址不能为空', trigger: 'blur'
                                  }">
                      <el-input v-model="domain.url"
                                placeholder="请输入链接网址！"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="是否新窗口打开:"
                                  label-width="130px"
                                  prop="word">
                      <el-switch :active-color="isSimple ? '#FD9112':'#185ED3'"
                                 v-model="domain.isNew"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-button @click.prevent="removeDomain(domain,index)">删除</el-button>
                    <el-button v-if="index == dynamicValidateForm.domains.length - 1"
                               class="addbtn"
                               :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                               @click.prevent="addDomain(domain)">添加</el-button>
                  </el-col>
                </el-row>
              </el-form>

            </div>
          </el-tab-pane>
        </el-tabs>

      </div>

    </div>

    <!-- 栏目 -->
    <el-dialog :before-close="closeColumn"
               width="26%"
               :visible.sync="dialogcolumnFormVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{columnTitle}}</div>
      </div>
      <el-form v-loading="columnLoading"
               :model="columnForm"
               :rules="columnRules"
               ref="columnForm"
               label-width="90px">
        <el-form-item label="栏目名称:"
                      prop="name">
          <el-input v-model="columnForm.name"
                    placeholder="必填，2-30个字"></el-input>
        </el-form-item>
        <el-form-item label="排序:"
                      prop="sort">
          <el-input v-model="columnForm.sort"
                    placeholder="必填，数字越大越靠前"></el-input>
        </el-form-item>
        <el-form-item label="简介:">
          <el-input v-model="columnForm.desc"
                    placeholder="不超过200个字"></el-input>
        </el-form-item>
        <el-form-item label="开启投稿:">
          <el-switch v-model="columnForm.allowPost"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button :disabled="columnLoading"
                   @click="closeColumn">取 消</el-button>
        <el-button :disabled="columnLoading"
                   type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitColumn('columnForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 频道 -->
    <el-dialog :before-close="closeChannel"
               width="26%"
               :visible.sync="dialogchannelFormVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{channelTitle}}</div>
      </div>
      <el-form v-loading="channelLoading"
               :model="channelForm"
               :rules="channelRules"
               ref="channelForm"
               label-width="90px">
        <el-form-item label="频道名称:"
                      prop="name">
          <el-input v-model="channelForm.name"
                    placeholder="必填，2-30个字"></el-input>
        </el-form-item>
        <el-form-item label="排序:"
                      prop="sort">
          <el-input v-model="channelForm.sort"
                    placeholder="必填，数字越大越靠前"></el-input>
        </el-form-item>
        <el-form-item label="简介:">
          <el-input v-model="channelForm.desc"
                    placeholder="不超过200个字"></el-input>
        </el-form-item>
        <!-- <el-form-item label="形象图:">
          <el-upload
            action="#"
            ref="elupload"
            list-type="picture-card"
            :on-change="onchange"
            :auto-upload="false">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt=""
                >
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
          </el-upload>
        </el-form-item> -->
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button :disabled='channelLoading'
                   @click="closeChannel">取 消</el-button>
        <el-button :disabled='channelLoading'
                   type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitChannel('channelForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看频道图片 -->
    <el-dialog :visible.sync="dialogVisible"
               class="seeImg">
      <img width="100%"
           :src="dialogImageUrl"
           alt="">
    </el-dialog>

    <div v-if="this.activeName == 'first' || this.activeName == 'third'"
         class="bottombtn">
      <div class="btn">
        <!-- <el-button :disabled="isRefresh" @click="closeForm">取消</el-button> -->
        <el-button :disabled="isRefresh"
                   @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
import {
  addWebsiteColumn,
  updateWebsiteColumn,
  listWebsiteColumn,
  deleteWebsiteColumn,
  getWebsiteColumn
} from "@/api/website";
import E from "wangeditor";
import getMD5 from "@/plugins/getMD5";
import SparkMD5 from "spark-md5";
import { picPrefix } from "@/constants/piccommon";
import { setWebSiteConfig, getWebSiteConfig } from "@/api/config";
export default {
  data () {
    return {
      data: [],

      parentId: 0,

      //频道相关内容
      channelLoading: false,
      dialogchannelFormVisible: false,
      channelTitle: '添加频道',
      channelForm: {
        name: '',
        sort: '',
        desc: '',
        imgs: []
      },
      channelRules: {
        name: [
          { required: true, message: '请输入频道名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'change' }
        ],

        desc: [
          { min: 0, max: 200, message: '长度在 0 到 200 个字符', trigger: 'blur' }
        ]
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      //频道上传相关
      kuai: 0,

      //栏目相关内容
      columnLoading: false,
      dialogcolumnFormVisible: false,
      columnTitle: '添加栏目',
      columnForm: {
        name: '',
        sort: '',
        desc: '',
        imgs: []
      },
      columnRules: {
        name: [
          { required: true, message: '请输入栏目名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'change' }
        ],

        desc: [
          { min: 0, max: 200, message: '长度在 0 到 200 个字符', trigger: 'blur' }
        ]
      },


      picPrefix,

      ruleForm: {
        title: "",
        word: "",
        abstract: '',
        theme: "",
        themePicture: "",
        themePictureMobile: "",
        content: '',
        websiteStatus: 'open'
      },

      //判断背景图是不是在上传
      isFile: false,
      isFileMo: false,
      isUpdata: false,
      picPrefix,
      thumbnailFile: null,
      thumbnailFileMo: null,
      themeList: [{
        title: '默认',
        value: 'default'
      }],
      roleList: [
        {
          title: '系统默认',
          value: 'default'
        },
        {
          title: '注册用户及认证用户',
          value: 'user'
        },
        {
          title: '仅认证用户',
          value: 'auth'
        }
      ],
      phoneEditor: "",
      rules: {
        title: [
          { required: true, message: '请输入网站标题', trigger: 'blur' },
          { min: 0, max: 40, message: "长度在 40 个字符以内", trigger: "blur" }
        ],
        word: [
          { required: true, message: '请输入网站关键词', trigger: 'blur' },
          { min: 1, max: 60, message: "长度在 60 个字符以内", trigger: "blur" }
        ],
        abstract: [
          { required: true, message: '请输入网站摘要', trigger: 'blur' },
          { min: 1, max: 200, message: "长度在 200 个字符以内", trigger: "blur" }
        ],

        websiteStatus: [
          { required: true, message: "请选择站点状态", trigger: "blur" }
        ],
        theme: [
          { required: true, message: "请选择站点模板", trigger: "blur" }
        ],

        desc: [
          {
            min: 0,
            max: 8000,
            message: "长度不得超过8000个字符",
            trigger: "blur"
          }
        ]
      },
      content: ``,

      //网站徽标
      logoFile: null,

      activeName: 'first',

      isRefresh: false,
      timer: '',//刷新栏目定时器

      dynamicValidateForm: {
        domains: [],
      }
    };
  },
  methods: {
    // allowDrop (draggingNode, dropNode, type) { //判断节点是否能被拖拽
    //   console.log(draggingNode, dropNode, type);
    // },

    //刷新表格
    refresh () {

      this.isRefresh = true
      this.getWebSiteConfigAsync();
      let val = {
        page: 0,
        pageSize: 50,
        parentId: 0
      }
      this.listWebsiteColumnAsync(val)
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },


    closeForm () {
      this.$message('正在开发中……')
    },

    importSensitive () {
      this.$message('正在开发中……')
    },


    //友情链接相关
    removeDomain (item, index) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        var index = this.dynamicValidateForm.domains.indexOf(item)
        if (index !== -1) {
          this.dynamicValidateForm.domains.splice(index, 1)
        }
        setTimeout(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }, 300);
      })

    },
    addDomain (domain) {
      this.dynamicValidateForm.domains.push({
        title: '',
        url: '',
        isNew: false
      });
    },

    handleClick (tab, event) {
      console.log(tab, event);
    },

    closeColumn () {
      this.$refs['columnForm'].resetFields();
      this.dialogcolumnFormVisible = false
    },
    closeChannel () {
      this.$refs['channelForm'].resetFields();
      this.dialogchannelFormVisible = false
    },

    //拖动事件
    nodedrop (moveNode, inNode, position, event) {
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.updateColumn()
      }, 4000);
    },
    async updateColumn () {
      this.isRefresh = true
      // console.log(moveNode, inNode, position, event);
      // console.log(this.data);
      let num = 100
      for (let i = 0; i < this.data.length; i++) {
        num--;
        let val = {
          "allowPicture": this.data[i].allowPicture,
          "allowText": this.data[i].allowText,
          "allowVideo": this.data[i].allowVideo,
          "desc": this.data[i].desc,
          "name": this.data[i].label,
          "parentId": 0,
          'id': this.data[i].id,
          "sort": num
        }
        console.log(val);
        let { status, data, message, errors } = await updateWebsiteColumn(val);
        // this.updateWebsiteColumnCopy(val)
        if (this.data[i].children) {
          for (let j = 0; j < this.data[i].children.length; j++) {
            num--;
            let value = {
              "allowPicture": this.data[i].children[j].allowPicture,
              "allowText": this.data[i].children[j].allowText,
              "allowVideo": this.data[i].children[j].allowVideo,
              "desc": this.data[i].children[j].desc,
              "name": this.data[i].children[j].label,
              "parentId": this.data[i].id,
              "sort": num,
              'id': this.data[i].children[j].id
            }
            let { status, data, message, errors } = await updateWebsiteColumn(value);

            console.log(value);
            // this.updateWebsiteColumnCopy(value)
          }
        }
      }
      let val = {
        page: 0,
        pageSize: 50,
        parentId: 0
      }
      this.listWebsiteColumnAsync(val)
    },
    allowDrop (dropNode, inNode, type) {
      // console.log(dropNode, inNode, type);
      if (dropNode.childNodes.length > 0) {
        if (inNode.level == 1) {
          if (type == 'next' || type == 'prev') {
            return type;
          } else {
            return;
          }
        }
        else {
          return;
        }
      } else {
        if (inNode.level == 2 && type == 'inner') {
          return;
        }
        return type
      }
    },
    change (node, data) {
      this.parentId = node.parent.data.id
      this.getWebsiteColumnAsync(data.id)
      if (node.level == 1) {
        this.channelTitle = '修改频道'
        this.dialogchannelFormVisible = true
      } else {
        this.columnTitle = '修改栏目'
        this.dialogcolumnFormVisible = true
      }


    },
    remove (node, data) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        this.deleteWebsiteColumnAsync(data.id)
      })
    },

    //频道事件
    appendChannel (n, d) {
      this.channelTitle = '新增频道'
      this.channelForm = {
        "imgs": [],
        "desc": '',
        "name": '',
        "sort": ''
      }
      this.dialogchannelFormVisible = true
    },
    submitChannel (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.channelLoading = true
          let val = {
            "allowPicture": 1,
            "allowText": 0,
            "allowVideo": 0,
            "desc": this.channelForm.desc,
            "name": this.channelForm.name,
            "parentId": 0,
            "sort": this.channelForm.sort
          }
          if (this.channelTitle == '新增频道') {
            this.addWebsiteColumnAsync(val)
          } else {
            val.id = this.channelForm.id
            this.updateWebsiteColumnAsync(val)
          }

        }
      })
    },

    handleRemove (file) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        for (let i = 0; i < this.channelForm.imgs.length; i++) {
          if (this.channelForm.imgs[i].uid == file.raw.uid) {
            this.channelForm.imgs.splice(i, 1)
          }
        }
        for (let i = 0; i < this.$refs.elupload.uploadFiles.length; i++) {
          if (this.$refs.elupload.uploadFiles[i].uid == file.raw.uid) {
            this.$refs.elupload.uploadFiles.splice(i, 1)
          }
        }
        setTimeout(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }, 1000);
      })
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onchange (file, fileList) {
      this.channelForm.imgs.push(file.raw)
    },

    //频道上传事件
    //自定义上传
    myUpload () {
      this.kuai = Math.ceil(100 / this.channelForm.imgs.length)
      // console.log(param)
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;

      // console.log('kuai',this.kuai)

      for (let i = 0; i < this.channelForm.imgs.length; i++) {
        if (this.channelForm.imgs[i].size > 450000) {
          bytesPerPiece = 260000;
        } else {
          bytesPerPiece = 16000;
        }

        getMD5(this.channelForm.imgs[i], md5 => {
          fileMD5 = md5;

          this.getFileInfoByHashAsyncChannel(
            fileMD5,
            this.channelForm.imgs[i],
            bytesPerPiece,
            totalPieces,
            i
          );
        });
      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsyncChannel (val, blob, b, t, i) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (status) {
        console.log(data);
      } else {
        this.fragmentationChannel(val, blob, b, t, i);
      }
    },

    //分片上传
    async fragmentationChannel (val, blob, bytesPerPiece, totalPieces, i) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      let fileProgress = 0

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        fileProgress = parseFloat((this.kuai / totalPieces).toFixed(2))

        // console.log('fileProgress',fileProgress)
        if (index < totalPieces) {
          // console.log('分片次数',index)
          await this.uploadPicChunkAsyncChannel(params, formData, blob, i, fileProgress);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          await this.uploadPicChunkMergeAsyncChannel(params, blob, i);
        }
        start = end;
        index++;
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsyncChannel (params, val, blob, i, fp) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        // this.uploadPicAsync(blob,i);
        // this.uploadErrorLength++
      } else {
        // console.log("分片第一步");
        this.progress = parseFloat((this.progress + fp).toFixed(2))
        // console.log('progress',this.progress)
        if (this.progress > 99) {
          this.progress = 99
        }
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsyncChannel (params, blob, i) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (status) {
        console.log('分片上传成功', data);
      } else {
        this.channelForm.imgs.splice(i, 1);
        // console.log(blob);
        // this.uploadPicAsync(blob,i);
      }
    },

    //栏目事件
    appendColumn (n, d) {
      this.columnTitle = '新增栏目'
      // this.columnForm = {
      //   "imgs":[],
      //   "desc": '',
      //   "name":'',
      //   "sort": ''
      // }
      this.columnForm.desc = ''
      this.parentId = d.id
      this.dialogcolumnFormVisible = true
      this.$refs['columnForm'].resetFields();
    },
    submitColumn (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.columnLoading = true
          let val = {
            "allowPicture": 1,
            "allowText": 0,
            "allowVideo": 0,
            "desc": this.columnForm.desc,
            "name": this.columnForm.name,
            "parentId": this.parentId,
            "sort": this.columnForm.sort,
            "allowPost": this.columnForm.allowPost?1:0
          }
          if (this.columnTitle == '新增栏目') {
            this.addWebsiteColumnAsync(val)
          } else {
            val.id = this.columnForm.id
            this.updateWebsiteColumnAsync(val)
          }


        }
      })
    },




    submitForm (formName) {
      console.log(formName, this.activeName);
      // if (this.activeName == 'first') {
      let websiteLinks = JSON.stringify(this.dynamicValidateForm.domains)
      if (websiteLinks) {
        this.$refs['dynamicValidateForm'].validate(valid => {
          if (valid) {
            this.$refs[formName].validate(valid => {
              if (valid) {

                // console.log(websiteLinks);
                let val = {
                  webTitle: this.ruleForm.title,
                  webKeywords: this.ruleForm.word,
                  webDescription: this.ruleForm.abstract,
                  webTheme: this.ruleForm.theme,
                  webLogo: this.thumbnailFile ? this.thumbnailFile.src : null,
                  webIcon: this.thumbnailFileMo ? this.thumbnailFileMo.src : null,
                  webFooter: this.phoneEditor.txt.html(),
                  websiteLinks: websiteLinks,
                  websiteStatus: this.ruleForm.websiteStatus
                }
                this.setWebSiteConfigAsync(val)

              }
            });

          } else {
            this.$message.warning('请填写友情链接!')
            return false;
          }
        });
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let val = {
              webTitle: this.ruleForm.title,
              webKeywords: this.ruleForm.word,
              webDescription: this.ruleForm.abstract,
              webTheme: this.ruleForm.theme,
              webLogo: this.thumbnailFile ? this.thumbnailFile.src : null,
              webIcon: this.thumbnailFileMo ? this.thumbnailFileMo.src : null,
              webFooter: this.phoneEditor.txt.html(),
              websiteLinks: null,
              websiteStatus: this.ruleForm.websiteStatus
            }
            this.setWebSiteConfigAsync(val)

          } else {
            this.$message.warning('请填写基本信息!')
            return false;
          }
        });
      }
      // }

    },


    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    closeForm () {
      this.$emit("closeForm");
    },

    deleteThumbnailFile () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除,
        customClass: 'messageBox-prompt-test'
      })
        .then(e => {
          this.thumbnailFile = null;
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },
    deleteThumbnailFileMo () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除,
        customClass: 'messageBox-prompt-test'
      })
        .then(e => {
          this.thumbnailFileMo = null;
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },

    onChange (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 20;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)
      this.isFile = true

      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      if (file.raw.size > 560000) {
        bytesPerPiece = 202020;
      } else {
        bytesPerPiece = 9888;
      }

      let fd = new FormData();
      fd.append("file", file.raw);
      getMD5(file.raw, md5 => {
        this.getFileInfoByHashAsync(
          md5,
          file.raw,
          bytesPerPiece,
          totalPieces,
          1
        );
      });
      // this.uploadPicAsync(fd, 1);
    },

    onChangeMo (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 20;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)
      this.isFileMo = true

      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      if (file.raw.size > 560000) {
        bytesPerPiece = 202020;
      } else {
        bytesPerPiece = 9888;
      }

      let fd = new FormData();
      fd.append("file", file.raw);
      getMD5(file.raw, md5 => {
        this.getFileInfoByHashAsyncMo(
          md5,
          file.raw,
          bytesPerPiece,
          totalPieces,
          1
        );
      });
      // this.uploadPicAsync(fd, 1);
    },

    //分片上传
    fragmentationMo (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          this.uploadPicChunkAsyncMo(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          this.uploadPicChunkMergeAsyncMo(params, blob, insert);
        }
        start = end;
        index++;
      }
    },
    //分片上传
    fragmentation (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          this.uploadPicChunkAsync(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          this.uploadPicChunkMergeAsync(params, blob, insert);
        }
        start = end;
        index++;
      }
    },

    //常规文件上传
    async uploadPicAsyncMo (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        if (insert === 1) {
          this.thumbnailFileMo = val;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        } else {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        }
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsyncMo (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsyncMo(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsyncMo (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsyncMo(fd, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
        } else {
          this.thumbnailFileMo = blob;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        }
      }
    },

    //常规文件上传
    async uploadPicAsync (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        if (insert === 1) {
          this.thumbnailFile = val;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        } else {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        }
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsync (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }
      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsyncMo (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentationMo(val, blob, b, t, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        } else {
          this.thumbnailFileMo = blob;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        }

      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsync (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentation(val, blob, b, t, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }

      }
    },

    //修改配置
    async updateWebsiteColumnAsync (val) {
      this.channelLoading = false
      this.columnLoading = false
      this.dialogchannelFormVisible = false
      this.dialogcolumnFormVisible = false
      let { status, data, message, errors } = await updateWebsiteColumn(val);
      if (status) {
        this.$message.success('修改成功！');
        let val = {
          page: 0,
          pageSize: 50,
          parentId: 0
        }
        this.listWebsiteColumnAsync(val)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //设置配置
    async addWebsiteColumnAsync (val) {
      this.channelLoading = false
      this.columnLoading = false
      this.channelForm = {
        name: '',
        sort: '',
        desc: '',
        imgs: []
      }
      this.columnForm = {
        name: '',
        sort: '',
        desc: '',
        imgs: []
      }
      this.dialogcolumnFormVisible = false
      this.dialogchannelFormVisible = false
      let { status, data, message, errors } = await addWebsiteColumn(val);
      if (status) {
        this.$message.success('创建成功！');
        let val = {
          page: 0,
          pageSize: 50,
          parentId: 0
        }
        this.listWebsiteColumnAsync(val)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取栏目/频道
    async getWebsiteColumnAsync (val) {
      let { status, data, message, errors } = await getWebsiteColumn(val);
      if (status) {
        this.channelForm = {
          imgs: [],
          "desc": data.desc,
          "name": data.name,
          "sort": data.sort,
          "id": data.id
        }
        this.columnForm = {
          imgs: [],
          "desc": data.desc,
          "name": data.name,
          "sort": data.sort,
          "id": data.id,
          "allowPost": data.allowPost==1?true:false
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //删除栏目/频道
    async deleteWebsiteColumnAsync (val) {
      let { status, data, message, errors } = await deleteWebsiteColumn(val);
      if (status) {
        this.$message.success('删除成功！');
        let val = {
          page: 0,
          pageSize: 50,
          parentId: 0
        }
        this.listWebsiteColumnAsync(val)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取频道和栏目类别
    async listWebsiteColumnAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listWebsiteColumn(val);
      if (status) {
        this.data = []
        for (let i = 0; i < data.length; i++) {
          this.data.push({
            id: data[i].id,
            label: data[i].name,
            children: [],
            allowPicture: data[i].allowPicture,
            allowText: data[i].allowText,
            allowVideo: data[i].allowVideo,
            desc: data[i].desc,
            sort: data[i].sort
          })
        }
        for (let i = 0; i < this.data.length; i++) {
          let childVal = {
            page: 0,
            pageSize: 50,
            parentId: this.data[i].id
          }
          let dataChildren = await listWebsiteColumn(childVal);
          if (dataChildren.data.length > 0) {
            for (let j = 0; j < dataChildren.data.length; j++) {
              this.data[i].children.push({
                id: dataChildren.data[j].id,
                label: dataChildren.data[j].name,
                allowPicture: dataChildren.data[j].allowPicture,
                allowText: dataChildren.data[j].allowText,
                allowVideo: dataChildren.data[j].allowVideo,
                desc: dataChildren.data[j].desc
              })

            }

          }

        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
      this.isRefresh = false

    },




    //获取配置
    async getWebSiteConfigAsync () {
      this.isRefresh = true
      let { status, data, message, errors } = await getWebSiteConfig();
      if (status) {
        if (data.webTitle) {
          this.ruleForm.title = data.webTitle
        }
        if (data.webKeywords) {
          this.ruleForm.word = data.webKeywords
        }
        if (data.webDescription) {
          this.ruleForm.abstract = data.webDescription
        }
        if (data.webTheme) {
          this.ruleForm.theme = data.webTheme
        }
        if (data.websiteStatus) {
          this.ruleForm.websiteStatus = data.websiteStatus
        }

        if (data.websiteLinks) {
          this.dynamicValidateForm.domains = JSON.parse(data.websiteLinks)
        }


        if (data.webIcon === null) {
          this.thumbnailFileMo = null
        } else {
          this.thumbnailFileMo = {
            src: data.webIcon
          }
        }
        if (data.webLogo === null) {
          this.thumbnailFile = null
        } else {
          this.thumbnailFile = {
            src: data.webLogo
          }
        }


        if (data.webFooter) {
          this.phoneEditor.txt.html(data.webFooter)
        }

        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },
    //设置配置
    async setWebSiteConfigAsync (val) {
      let { status, data, message, errors } = await setWebSiteConfig(val);
      if (status) {
        this.$message.success('设置成功！');
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

  },
  created () {
    let val = {
      page: 0,
      pageSize: 50,
      parentId: 0
    }
    this.listWebsiteColumnAsync(val)
    this.getWebSiteConfigAsync()
  },
  mounted () {
    var that = this;
    this.phoneEditor = new E("#websiteEditorElem");
    // 上传图片到服务器，base64形式
    // this.phoneEditor.customConfig.uploadImgShowBase64 = true;
    // 隐藏网络图片
    this.phoneEditor.customConfig.showLinkImg = false;

    // 配置服务器端地址
    // this.phoneEditor.customConfig.uploadImgServer = 'https://httpbin.org/post'

    // 自定义菜单配置
    this.phoneEditor.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      'link',  // 插入链接
      // 'list',  // 列表
      "justify", // 对齐方式
      "quote", // 引用
      // "image", // 插入图片
      // 'table',  // 表格
      // 'video',  // 插入视频
      'code',  // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];

    // 将图片大小限制为 50M
    this.phoneEditor.customConfig.uploadImgMaxSize = 50 * 1024 * 1024;

    // 限制一次最多上传 10 张图片
    this.phoneEditor.customConfig.uploadImgMaxLength = 10;

    //上传图片事件
    this.phoneEditor.customConfig.customUploadImg = function (files, insert) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      let icon = '<i style="font-size:24px" class="el-icon-loading"></i>'
      that.phoneEditor.txt.html(that.phoneEditor.txt.html() + icon)

      files.forEach(item => {

        if (item.size > 560000) {
          bytesPerPiece = 202020;
        } else {
          bytesPerPiece = 9888;
        }
        getMD5(item, md5 => {
          that.getFileInfoByHashAsync(
            md5,
            item,
            bytesPerPiece,
            totalPieces,
            insert
          );
        });

      });


    };



    // 创建一个富文本编辑器
    this.phoneEditor.create();
    // 富文本内容
    this.phoneEditor.txt.html(this.ruleForm.content);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./sitemanage.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
.basicssetup {
  position: relative;
}
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0px;
  right: 2px;
  // top: 0;
  z-index: 5;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

/deep/ .w-e-text-container {
  z-index: 0 !important;
}

.bottombtn /deep/ .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn /deep/ .el-button--primary {
  background-color: #185ed3;
}
/deep/ .el-form-item__label {
  font-weight: 600;
}

/deep/ .el-loading-mask {
  z-index: 2;
}
/deep/ .el-icon-circle-close {
  margin-top: 150px;
}

.custom-tree-node {
  display: flex;
  align-items: center;
  position: relative;
  // justify-content: center;
  width: 100%;
}

.custom-tree-node /deep/ .btn {
  position: absolute;
  right: 10px;
}

/deep/ .el-upload-list__item img {
  position: absolute;
}

/deep/ .el-upload-list__item,
/deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
}
/deep/ .el-upload--picture-card {
  line-height: 90px;
}
.seeImg /deep/ .el-dialog {
  margin-top: 8vh !important;
}
.seeImg /deep/ .el-dialog .el-dialog__header {
  padding-top: 35px !important;
}

/deep/
  .is-dragging
  .is-drop-inner
  .el-tree-node__content
  .custom-tree-node
  span {
  background-color: #dadada !important;
}
/deep/
  .is-dragging
  .is-drop-inner
  .el-tree-node__children
  .custom-tree-node
  span {
  background-color: transparent !important;
}

/deep/ .el-tree-node > .el-tree-node__content {
  background: #f5f5f5;
  border-radius: 5px;
  // font-weight: bold;
  color: #242433;
  line-height: 32px;
  height: auto;
  font-size: 16px;
  border: 2px dotted transparent !important;
  // margin: 3px 0;
  .el-tree-node__label {
    font-size: 16px;
  }
  .el-tree-node__expand-icon {
    display: block;
    width: 5px;
    height: 5px;
    background: #4198ff;
    border-radius: 50%;
    padding: 0;
    // margin-right: 15px;
    // margin-left: 15px;
    border: 10px solid #f5f5f5 !important;
    &::before {
      content: "";
    }
  }
}
/deep/ .el-tree-node div {
  margin: 4px 0;
}
/deep/ .el-tree-node__children > .el-tree-node .el-tree-node__content {
  background: rgba(243, 248, 255, 1) !important;
  border-radius: 5px;
  font-weight: 400;
  line-height: 32px;
  height: auto;
  color: #7c7c8a;
  transition: 0.3s;
  margin-top: 0 !important;
  &:hover {
    background: RGBA(221, 235, 255, 1) !important;
  }
  .el-tree-node__label {
    font-size: 14px;
  }
  .el-tree-node__expand-icon {
    display: block;
    width: 20px;
    height: 20px;
    background-color: transparent !important;
    border: none !important;
    // border: 5px solid transparent !important;
    // border-color: transparent !important;
  }
}
/deep/ .el-tree-node__children {
  // margin-bottom: 0px !important;
  height: 80%;
}
.sitemanage /deep/ .el-image-viewer__close {
  width: 5000px;
  height: 5000px;
  border-radius: 0%;
}

.upbg /deep/ .w-e-text-container {
  z-index: 3 !important;
}
.upbg /deep/ .w-e-menu {
  z-index: 5 !important;
}
.upbg /deep/ .w-e-droplist {
  z-index: 100000 !important;
}


</style>
